import { forwardRef } from 'react';

import { cn } from '../../utils/cn';

export const Input = forwardRef(function Input(
  { className, type = 'text', invalid = false, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      aria-invalid={invalid || undefined}
      data-ds-id={invalid ? 'ds/input/text--error' : 'ds/input/text--default'}
      className={cn(
        'flex w-full rounded-ds-md bg-card border border-border px-space-4 py-space-3 text-type-body font-body text-foreground placeholder:text-stone-400 focus:border-sage-500 focus:ring-4 focus:ring-sage-glow-soft focus:outline-none disabled:cursor-not-allowed disabled:opacity-50',
        invalid && 'border-danger-500',
        className,
      )}
      {...props}
    />
  );
});
